import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { cpf, cnpj } from "cpf-cnpj-validator";
import Api from "../../Api";
import ClientsForm from "./Form";
import Section from "../../parts/Section";
import { SessionContext } from "../../SessionContext";
import { Client, UIValue } from "../../types";

const ClientsCreate = () => {
  const navigate = useNavigate();
  const { user } = useContext(SessionContext);
  const [client, setClient] = useState<Client>({
    uuid: "",
    sellerUuid: user!.uuid,
    name: "",
    nameNormalized: "",
    type: "pf",
    document: "",
    companyUuid: "",
    street: "",
    number: "",
    complement: "",
    area: "",
    zipcode: "",
    city: "",
    state: "",
    contactName: "",
    email: "",
    mobile: "",
    phone: "",
    since: new Date(),
    technicalNotes: [],
  });
  const [error, setError] = useState(false);
  const [errorDoc, setErrorDoc] = useState(false);

  const changeClient = (key: string) => (value: UIValue) => {
    setClient((client) => ({ ...client, [key]: value }));
  };

  const save = async () => {
    setError(false);
    setErrorDoc(false);

    const validateDocument = client.type === "pf" ? cpf.isValid : cnpj.isValid;
    if (!validateDocument(client.document)) {
      setErrorDoc(true);
      return;
    }

    const result = await Api.clientsCreate(client);
    result.success ? navigate("/clientes") : setError(true);
  };

  return (
    <Section className="p-4 pb-32">
      <ClientsForm
        client={client}
        buttonText={"Cadastrar cliente"}
        onSubmit={save}
        onChange={changeClient}
        error={error}
        errorDoc={errorDoc}
      />
    </Section>
  );
};

export default ClientsCreate;
